import React from 'react';
const CarDocuments = () => <div style={{padding:32}}>Зураг, баримт бичиг (stub)</div>;
export default CarDocuments;
